import { Grid } from "@mui/material"
import { FormAutoCompleteTableSelect } from "../../../../components/hook-form/form-autocomplete-table-select.dynamic.component"
import FormInput from "../../../query-builder/hooks-form-querybuilder/form-input.component"
import { useLoadData } from "../../../../hooks/useLoadData";
import { ApiResponse } from "../../../../models/api-response";
import { projectsApiKeyStore } from "../../../../api/projects-api-key-store";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useAuthorize } from "../../../../hooks/use-authorize";
import { UserPermissionName } from "../../../../models/user-permission-name";

interface ServicePricingFormComponent {
    officeID: any;
    pricingID: any
    onSelectPrice: (pricingID: any) => void;
}
export const ServicePricingFormComponent = ({ officeID, pricingID, onSelectPrice }: ServicePricingFormComponent) => {

    const { setValue, getValues } = useFormContext();
    const [selectedPriceData, setSelectedPriceData] = useState<any>();
    const [pricingDetails, setPricingDetails] = useState<any>();

    const { data: pricingData, isLoading: isPricingLoading } = useLoadData<ApiResponse<any[]>>(projectsApiKeyStore.getProjectPricingListByOffice(officeID));

    const pricingOptionMap: Record<any, string> = {
        AllNewStarts: 'All New Starts',
        AllLots: 'All Lots',
        AllNewTH: 'All New TH',
        AllNewSFR: 'All New SFR',
        AllNewCM: 'All New Commercial (CM)'
    };

    const showUpdatedPricing = (updatedPrice: any) => {
        onSelectPrice(updatedPrice?.pricingListID);
        setSelectedPriceData(updatedPrice);
        setValue('officePrice', { pricingListID: updatedPrice?.pricingListID ?? '', pricingListName: updatedPrice?.pricingListName ?? "" })
        setValue('priceStartDate', updatedPrice?.pricingStartDate ?? '');
        setValue('priceEndDate', updatedPrice?.pricingEndDate ?? '');
        setValue('priceApplyTo', updatedPrice?.pricingListAppliesToLotTypeLabel ?? '');
    }

    useEffect(() => {
        if (pricingData) {
            const updatedPriceData = pricingData?.data?.map(item => ({
                ...item,
                pricingListAppliesToLotTypeLabel:
                    pricingOptionMap[item.pricingListAppliesToLotType] || null,
            }));
            if (pricingID) {
                const setPrice = updatedPriceData?.find((item: any) => item?.pricingListID === pricingID)
                showUpdatedPricing(setPrice);
            }
            setPricingDetails(updatedPriceData)
        }
    }, [pricingData])


    const handlePriceChange = (row: any) => {
        if (row) {
            setValue('priceStartDate', row?.pricingStartDate ?? '');
            setValue('priceEndDate', row?.pricingEndDate ?? '');
            setValue('priceApplyTo', row?.pricingListAppliesToLotTypeLabel ?? '');
            onSelectPrice(row?.pricingListID);
        }
        else {
            setValue('officePrice', { pricingListID: selectedPriceData?.pricingListID ?? '', pricingListName: selectedPriceData?.pricingListName ?? "" })
            setValue('priceStartDate', selectedPriceData?.pricingStartDate ?? '');
            setValue('priceEndDate', selectedPriceData?.pricingEndDate ?? '');
            setValue('priceApplyTo', selectedPriceData?.pricingListAppliesToLotTypeLabel ?? '');
            onSelectPrice(selectedPriceData?.pricingListID);
        }
    };

    return (
        <>
            <Grid item lg={2} sm={2} xl={2} xs={2}>
                <FormAutoCompleteTableSelect
                    name="officePrice"
                    label="Price List Name"
                    dataItems={pricingDetails}
                    onChange={handlePriceChange}
                    idKey="pricingListID"
                    optionWidth={'900px'}
                    isParentLoading={isPricingLoading}
                    getOptionLabel={(o) => o.pricingListName}
                    columns={[
                        { header: "Pricing List Name", field: "pricingListName", width: "2fr" },
                        { header: "Start Date", field: "pricingStartDate", width: "1fr" },
                        { header: "End Date", field: "pricingEndDate", width: "1fr" },
                        { header: "Pricing List Applies To", field: "pricingListAppliesToLotTypeLabel", width: "2fr" }
                    ]}
                    optionsValueKey="pricingListID"
                />
            </Grid>
            <Grid item lg={2} sm={2} xl={2} xs={2}>
                <FormInput name="priceStartDate" label="Pricing Start Date" isParentLoading={isPricingLoading} disabled />
            </Grid>
            <Grid item lg={2} sm={2} xl={2} xs={2}>
                <FormInput name="priceEndDate" label="Pricing End Date" isParentLoading={isPricingLoading} disabled />
            </Grid>
            <Grid item lg={2} sm={2} xl={2} xs={2}>
                <FormInput name="priceApplyTo" label="Pricing List Applies To" disabled />
            </Grid>
        </>)
}